import axios from 'axios';

export default axios.create({
  //baseURL: 'https://localhost:44753'
  baseURL : 'https://api.services.woradelivery.com'
});


//produrl
// http://167.172.111.162/WORA/index.php